import styled from 'styled-components'
import { BP } from 'resources/constants'

export const Wrapper = styled.div`
  text-align: center;

  @media (min-width: ${BP.sm.min}) {
    width: ${BP.xs.min};
    margin: auto;
  }

  h1 {
    ${props => props.theme.css.heading1};
    font-size: 30px;

    &::after {
      content: '';
      display: block;
      width: 40px;
      height: 1px;
      margin: 22px auto;
      background-color: ${props => props.theme.palette.general.strong};
    }
  }

  p {
    line-height: 22px;

    strong {
      font-weight: ${props => props.theme.font.default.bold};
    }
  }

  button {
    margin: 24px auto;
    width: 300px;
    padding: 17px;
    background: ${props => props.theme.palette.general.strong};
    border-color: ${props => props.theme.palette.general.strong};
  }
`
